<div
  class="ellipsis-text text-wrap"
  [matTooltip]="text"
  [matTooltipDisabled]="!showTooltip"
  [matTooltipClass]="'text-nowrap'"
  [matTooltipPosition]="'below'"
>
  <span class="text-line">{{ text }}</span>
</div>
